import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { getReportingRole } from 'src/components/AuthProvider/authUtils';
import { transformCorpResponse } from './datadogRumTransformers';
import { DataDogRumCorpContext } from './datadogRumApi';

export const useBuildRumContext = (): DataDogRumCorpContext => {
  const {
    corpId,
    enterpriseData: {
      isInternalAdminUser,
      isFinancialAdminUser,
      isParentAdminUser,
    },
    corpData,
  } = useAuth();

  const role = getReportingRole(
    isInternalAdminUser,
    isFinancialAdminUser,
    isParentAdminUser,
    corpData?.signUpType
  );

  if (corpData) {
    return transformCorpResponse(corpData, role);
  }

  // Fallback object when no corp is found
  const noCorpFoundFallback: DataDogRumCorpContext = {
    corpId,
    corpName: '',
    corpType: '',
    corpUserRole: role.toUpperCase(),
  };

  return noCorpFoundFallback;
};
